/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.9
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ProfileCourseProgress } from '../model';
// @ts-ignore
import { Success } from '../model';
/**
 * CourseProgressApi - axios parameter creator
 * @export
 */
export const CourseProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The list contains a mapping of the course_id and the related course progress status
         * @summary Returns the list of courses a User has progress on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseProgressGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/course/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Passing a course id and a progress status to update the progress_status on a course for a User.
         * @summary Updates the progress on a course(e-learning) for a User.
         * @param {ProfileCourseProgress} profileCourseProgress The course id and status to update the progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseProgressPost: async (profileCourseProgress: ProfileCourseProgress, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileCourseProgress' is not null or undefined
            assertParamExists('courseProgressPost', 'profileCourseProgress', profileCourseProgress)
            const localVarPath = `/course/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileCourseProgress, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseProgressApi - functional programming interface
 * @export
 */
export const CourseProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * The list contains a mapping of the course_id and the related course progress status
         * @summary Returns the list of courses a User has progress on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseProgressGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileCourseProgress>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseProgressGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Passing a course id and a progress status to update the progress_status on a course for a User.
         * @summary Updates the progress on a course(e-learning) for a User.
         * @param {ProfileCourseProgress} profileCourseProgress The course id and status to update the progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseProgressPost(profileCourseProgress: ProfileCourseProgress, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Success>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseProgressPost(profileCourseProgress, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CourseProgressApi - factory interface
 * @export
 */
export const CourseProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseProgressApiFp(configuration)
    return {
        /**
         * The list contains a mapping of the course_id and the related course progress status
         * @summary Returns the list of courses a User has progress on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseProgressGet(options?: any): AxiosPromise<Array<ProfileCourseProgress>> {
            return localVarFp.courseProgressGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Passing a course id and a progress status to update the progress_status on a course for a User.
         * @summary Updates the progress on a course(e-learning) for a User.
         * @param {ProfileCourseProgress} profileCourseProgress The course id and status to update the progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseProgressPost(profileCourseProgress: ProfileCourseProgress, options?: any): AxiosPromise<Success> {
            return localVarFp.courseProgressPost(profileCourseProgress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseProgressApi - object-oriented interface
 * @export
 * @class CourseProgressApi
 * @extends {BaseAPI}
 */
export class CourseProgressApi extends BaseAPI {
    /**
     * The list contains a mapping of the course_id and the related course progress status
     * @summary Returns the list of courses a User has progress on.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseProgressApi
     */
    public courseProgressGet(options?: any) {
        return CourseProgressApiFp(this.configuration).courseProgressGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Passing a course id and a progress status to update the progress_status on a course for a User.
     * @summary Updates the progress on a course(e-learning) for a User.
     * @param {ProfileCourseProgress} profileCourseProgress The course id and status to update the progress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseProgressApi
     */
    public courseProgressPost(profileCourseProgress: ProfileCourseProgress, options?: any) {
        return CourseProgressApiFp(this.configuration).courseProgressPost(profileCourseProgress, options).then((request) => request(this.axios, this.basePath));
    }
}
